import { render, staticRenderFns } from "./get-in-touch.vue?vue&type=template&id=c12d1cba&scoped=true&"
import script from "./get-in-touch.vue?vue&type=script&lang=ts&"
export * from "./get-in-touch.vue?vue&type=script&lang=ts&"
import style0 from "./get-in-touch.vue?vue&type=style&index=0&id=c12d1cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12d1cba",
  null
  
)

export default component.exports